const impressumContent = {
  title: "Impressum",
  sections: [
    {
      title: "Angaben gemäß § 5 TMG:",
      lines: [
        'Anglerverein "Angelfreunde 1866" e.V. Berlin',
        "eingetragener Verein beim Amtsgericht Charlottenburg",
        "Hausburgstraße 13, 10249 Berlin",
      ],
    },
    {
      title: "Vertreten durch:",
      lines: ["Paul Müller (Vorsitzender)"],
    },
    {
      title: "Kontakt:",
      lines: [
        <>
          E-Mail:{" "}
          <a
            href="mailto:info@angelfreunde1866.de"
            className="text-sky-600 hover:text-sky-700"
          >
            info@angelfreunde1866.de
          </a>
        </>,
      ],
    },
    {
      title: "Bankverbindung vom Vereinskonto:",
      lines: [
        'AV Angelfreunde 1866 e.V.',
        "IBAN: DE45 1009 0000 5624 8940 08",
        "BIC: BEVODEBB",
        "Berliner Volksbank",
      ],
    },
    {
      title: "Inhaltlich verantwortlich gemäß § 55 Abs. 2 RStV:",
      lines: ["Paul Müller, Ben Pardun"],
    },
    {
      title: "Entwicklung und Gestaltung der Website:",
      lines: ["Ben Pardun"],
    },
    {
      title: "Haftungsausschluss:",
      lines: [
        "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
      ],
    },
    {
      title: "Urheberrecht:",
      lines: [
        "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedarf der schriftlichen Zustimmung des jeweiligen Autors oder Erstellers.",
      ],
    },
  ],
  lastUpdated: "Letzte Aktualisierung: Oktober 2025",
};

export default impressumContent;
